import { render, staticRenderFns } from "./PersonView.vue?vue&type=template&id=14ffc914&"
import script from "./PersonView.vue?vue&type=script&lang=js&"
export * from "./PersonView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports